__turbopack_context__.v({
  "Label": "rFrxHG_Label",
  "actionable": "rFrxHG_actionable",
  "controls": "rFrxHG_controls",
  "inline": "rFrxHG_inline",
  "primary": "rFrxHG_primary",
  "primaryBtn": "rFrxHG_primaryBtn",
  "root": "rFrxHG_root",
  "secondaryBtn": "rFrxHG_secondaryBtn",
});
